/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionSetData } from './PermissionSetData';
import {
    PermissionSetDataFromJSON,
    PermissionSetDataFromJSONTyped,
    PermissionSetDataToJSON,
    PermissionSetDataToJSONTyped,
} from './PermissionSetData';

/**
 * 
 * @export
 * @interface PermissionSetResponse
 */
export interface PermissionSetResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof PermissionSetResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof PermissionSetResponse
     */
    error?: string;
    /**
     * 
     * @type {PermissionSetData}
     * @memberof PermissionSetResponse
     */
    data?: PermissionSetData;
}

/**
 * Check if a given object implements the PermissionSetResponse interface.
 */
export function instanceOfPermissionSetResponse(value: object): value is PermissionSetResponse {
    return true;
}

export function PermissionSetResponseFromJSON(json: any): PermissionSetResponse {
    return PermissionSetResponseFromJSONTyped(json, false);
}

export function PermissionSetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'data': json['data'] == null ? undefined : PermissionSetDataFromJSON(json['data']),
    };
}

export function PermissionSetResponseToJSON(json: any): PermissionSetResponse {
    return PermissionSetResponseToJSONTyped(json, false);
}

export function PermissionSetResponseToJSONTyped(value?: PermissionSetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'data': PermissionSetDataToJSON(value['data']),
    };
}

